import { z } from "zod";
export const handHygieneSchema = z
  .object({
    location: z.string().min(1, "Invalid location"),
    auditDate: z.coerce.date(),
    staffObserved: z.string(),
    otherStaffObserved: z.string().optional(),
    staffInitials: z.string(),
    methodUsed: z.string(),
    handHygieneReason: z.string(),
    otherReason: z.string().optional(),
    compliant: z.string(),
    nonCompliantDescription: z.array(z.string()).optional(),
    otherNonCompliant: z.string().optional(),
    observer: z.string().min(1, "Invalid observer"),
  })
  .superRefine(
    (
      {
        staffObserved,
        otherStaffObserved,
        handHygieneReason,
        otherReason,
        nonCompliantDescription,
        compliant,
        otherNonCompliant,
        auditDate,
      },
      refinementContext,
    ) => {
      if (
        staffObserved === "Other" &&
        (!otherStaffObserved || otherStaffObserved.trim().length < 1)
      ) {
        refinementContext.addIssue({
          code: z.ZodIssueCode.custom,
          message: "required",
          path: ["otherStaffObserved"],
        });
      }

      if (
        handHygieneReason === "Other" &&
        (!otherReason || otherReason.trim().length < 1)
      ) {
        refinementContext.addIssue({
          code: z.ZodIssueCode.custom,
          message: "required",
          path: ["otherReason"],
        });
      }

      if (compliant === "No") {
        if (!nonCompliantDescription || nonCompliantDescription?.length < 1) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "At least one selection required",
            path: ["nonCompliantDescription"],
          });
        }

        if (
          nonCompliantDescription !== undefined &&
          nonCompliantDescription.includes("Other") &&
          (!otherNonCompliant || otherNonCompliant.trim().length < 1)
        ) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "required",
            path: ["otherNonCompliant"],
          });
        }
      }

      if (auditDate > new Date(Date.now())) {
        refinementContext.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Date cannot be in the future.",
          path: ["auditDate"],
        });
      }
      const date = new Date();
      if (date > new Date(date.getFullYear(), date.getMonth(), 5)) {
        if (auditDate < new Date(date.getFullYear(), date.getMonth(), 1)) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Date not in submission window",
            path: ["auditDate"],
          });
        }
      } else {
        if (auditDate < new Date(date.getFullYear(), date.getMonth() - 1, 1)) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Date not in submission window",
            path: ["auditDate"],
          });
        }
      }
    },
  );
